<!-- UK -->
<!-- https://pub.s7.exacttarget.com/nrmfiyh42jv -->
<div class="layout-row">
  <div class="layout-column align-middle newsletter-form">
    <h2 class="spacer-bottom-8">Want to read more?</h2>
    <p>Get a fresh slice of money news, and the latest GoHenry updates, direct to your inbox.</p>
    <iframe [src]="iframeSrc" frameborder="0" width="100%" height="160px" title="Newsletter form"></iframe>
    <p class="privacy-policy">Read our <a href="https://www.gohenry.com/uk/terms-and-conditions/privacy-policy/"
      target="_blank">Privacy Policy</a>
    </p>
  </div>
</div>
